import { useMemo } from 'react';

import DataTable from 'components/dataTable/dataTable';

import { APIError } from 'types/error';

import { sortByDate } from 'utils/sort';

import { OrderPwcData } from '../../types';
import { TransactionDetails } from '../transactionDetails/transactionDetails';
import { ChargeTableCell } from './components/chargeTableCell';
import { TransactionType, formatTransaction } from './formatTransaction';
import { COLUMNS } from './keys';
import { Container } from './styles';

export interface OrderDetailsProps {
  orderPwcData: OrderPwcData;
  shouldShowExchangeDetailsSection: boolean;
  shouldShowSettlementDetailsSection: boolean;
  isS4cUser: boolean;
  cancelRefund: {
    trigger: (orderUuid: string, refundUuid: string) => Promise<{ error?: APIError }>;
    isLoading: boolean;
  };
}

export const TransactionsListSection = ({
  orderPwcData,
  shouldShowExchangeDetailsSection,
  shouldShowSettlementDetailsSection,
  isS4cUser,
  cancelRefund,
}: OrderDetailsProps) => {
  const { charges, general, refunds } = orderPwcData;
  const { fiatCurrencyCode } = general;

  const transactions = useMemo(() => {
    const formattedCharges = charges.map((c) => formatTransaction({ transaction: c, fiatCurrencyCode, type: TransactionType.CHARGE }));
    const formattedRefunds = refunds.map((r) => formatTransaction({ transaction: r, fiatCurrencyCode, type: TransactionType.REFUND }));
    return sortByDate([...formattedCharges, ...formattedRefunds], (t) => t.lastUpdateAt, 'desc');
  }, [charges, refunds, fiatCurrencyCode]);

  return (
    <Container>
      <DataTable
        columns={COLUMNS}
        rows={transactions}
        CellComponent={ChargeTableCell}
        isExpandable
        /* eslint-disable react/no-unstable-nested-components */
        expandableComponent={(rowId) => (
          <TransactionDetails
            orderPwcData={orderPwcData}
            shouldShowExchangeDetailsSection={shouldShowExchangeDetailsSection}
            shouldShowSettlementDetailsSection={shouldShowSettlementDetailsSection}
            rowId={rowId}
            isS4cUser={isS4cUser}
            transactions={transactions}
            cancelRefund={cancelRefund}
          />
        )}
      />
    </Container>
  );
};
